import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface CompletedSession {
  examId: string;
  categoryId: string;
  score: number;
  correctCount: number;
  totalQuestions: number;
  totalTime: number;
  completedAt: string;
}

interface PracticeStoreState {
  completedSessions: CompletedSession[];
  addCompletedSession: (session: CompletedSession) => void;
  getSessionsForExam: (examId: string) => CompletedSession[];
  clearHistory: () => void;
}

export const usePracticeStore = create<PracticeStoreState>()(
  persist(
    (set, get) => ({
      completedSessions: [],
      addCompletedSession: (session) =>
        set((state) => ({
          completedSessions: [session, ...state.completedSessions].slice(0, 100),
        })),
      getSessionsForExam: (examId) =>
        get().completedSessions.filter((s) => s.examId === examId),
      clearHistory: () => set({ completedSessions: [] }),
    }),
    { name: 'certexam-practice' }
  )
);
